export default {
    URL_API: 'https://devapi.soundanalytics.cl/v2.0'
}
